import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import SiteConfig from '../../config/sites/'
import userMenuConfig from '../../common/constants/userMenuConfig'
import { getCurrentSiteDomain } from '../../common/utils/sites'
import assetsPath from '../../common/utils/assetsPath'
import config from '../../common/config'

const ssoServerHost = config.sso.SERVER_HOST
const defaultUserImageUrl = assetsPath() + SiteConfig['defaults'].ui.default_user_image_path

class PageOffCanvasRight extends React.Component {
  static propTypes = {
    currentSite: PropTypes.string.isRequired,
    showRightOffCanvas: PropTypes.bool.isRequired,
    user: PropTypes.object
  }

  render () {
    let offCanvasRightClass = classNames(
      'page__off-canvas--right',
      {
        'page__off-canvas--is-active': this.props.showRightOffCanvas
      }
    )

    return (
      <div className={offCanvasRightClass}>
        {this.renderNav()}
      </div>
    )
  }

  renderNav () {
    let { user } = this.props
    const hasUserProfile = user && user.profile
    return hasUserProfile
      ? this.renderSignedInNav(user)
      : this.renderSignedOutNav(user)
  }

  renderMenu (config) {
    const { user } = this.props

    return (
      <ul>
        {config.map((item, index) => {
          const iconClassName = item.icon + ' -size-medium -color-grey-dark'
          const userProfileUrl = item.link.replace('{username}', user.profile.username)
          return (
            <li key={index}>
              <a href={userProfileUrl} className='off-canvas-right__link'>
                {item.name}
                <i className={iconClassName} />
              </a>
            </li>
          )
        })}
      </ul>
    )
  }

  renderCartSummary (cart) {
    const cartEntryCount = cart && cart.entries ? cart.entries.length : ''
    const { currentSite } = this.props
    const currentSiteDomain = getCurrentSiteDomain(currentSite)
    const cartSummaryClassNames = classNames('shopping-cart-summary', {
      'is-empty': cartEntryCount === 0 || cartEntryCount === ''
    })
    const cartUrl = `//${currentSiteDomain}/cart`
    return (
      <div className='off-canvas-right__cart'>
        <a href={cartUrl} ref='nofollow'>
          <div className={cartSummaryClassNames}>
            <i className='e-icon -icon-cart -margin-right' />
            <span className='shopping-cart-summary__count'>{cartEntryCount}</span>
          </div>
        </a>
      </div>
    )
  }

  renderSignedInNav (user) {
    const { currentSite } = this.props
    const avatarUrl = user.profile.image ? user.profile.image : defaultUserImageUrl
    const userProfileUrl = `https://${getCurrentSiteDomain(currentSite)}/user/${user.profile.username}`
    const signOutUrl = `${ssoServerHost}/sign_out?to=${currentSite}`

    return (
      <div className='off-canvas-right'>
        <div className='off-canvas-right__top'>
          <div className='media'>
            <a href={userProfileUrl} className='media__item'>
              <img alt={user.profile.username} className='off-canvas-right__avatar' src={avatarUrl} />
            </a>

            <div className='media__body'>
              <a
                href={userProfileUrl}
                className='off-canvas-right__username'
              >
                {user.profile.username}
              </a>
              <br />
              {user.profile.balance &&
                <span className='off-canvas-right__balance'>${user.profile.balance}</span>
              }
            </div>
          </div>

          {this.renderCartSummary(user.cart)}

        </div>

        <strong className='off-canvas-right__section-heading'>account</strong>
        {this.renderMenu(userMenuConfig.buyer)}

        <strong className='off-canvas-right__section-heading'>author</strong>

        {user.profile.is_author
          ? this.renderMenu(userMenuConfig.author)
          : this.renderMenu(userMenuConfig.nonAuthor)
        }

        <ul>
          <li>
            <a href={signOutUrl} className='off-canvas-right__link--logout' >
              Sign out
              <i className='e-icon -icon-logout -size-medium -color-white' />
            </a>
          </li>
        </ul>
      </div>
    )
  }

  renderSignedOutNav (user) {
    let { currentSite } = this.props
    const signUpUrl = `${ssoServerHost}/sign_up?to=${currentSite}`
    const signInUrl = `${ssoServerHost}/sign_in?to=${currentSite}`
    return (
      <div className='off-canvas-right'>
        {this.renderGuestCartSummary(user.cart)}
        <a href={signUpUrl} className='off-canvas-right__link'>
          Create an Envato Account
          <i className='e-icon -icon-envato' />
        </a>
        <a href={signInUrl} className='off-canvas-right__link' rel='nofollow'>
          Sign In
          <i className='e-icon -icon-login' />
        </a>
      </div>
    )
  }

  renderGuestCartSummary (cart) {
    const cartEntryCount = cart && cart.entries ? cart.entries.length : ''
    const cartSummaryClassNames = classNames('shopping-cart-summary', {
      'is-empty': cartEntryCount === 0 || cartEntryCount === ''
    })
    return (
      <a className='off-canvas-right__link--cart' href='/cart' ref='nofollow'>
        Guest Cart
        <div className={cartSummaryClassNames}>
          <span className='shopping-cart-summary__count'>{cartEntryCount}</span>
          <i className='e-icon -icon-cart -margin-right' />
        </div>
      </a>
    )
  }
}

export default PageOffCanvasRight



// WEBPACK FOOTER //
// ./client/components/pageOffCanvasRight.js